<template>
  <!-- メールアクション -->
  <transition name="right">
    <div v-if="isOpenEmailMenu" class="email-action-container disp-scroll" style="position: absolute; top: 0; right: 0; height: 100%; width: 40%; min-width: 400px; background: #FEFEFE; padding: 16px; z-index: 201; overflow: auto;">
      <MailActionContent
        :isOpenEmailMenu="isOpenEmailMenu"
        :bulk="bulk"
        :chatbots="chatbots"
        :recordingInterviews="recordingInterviews"
        :users="users"
        :options="options"
        :sendLoadding="sendLoadding"
        :emailTemplates="emailTemplates"
        :sendEmailTemplate="sendEmailTemplate"
        :changeEmailTemplate="changeEmailTemplate"
        :sendEmailToSeeker="sendEmailToSeeker"
        :copyLink="copyLink"
        :tempSaveEmail="tempSaveEmail"
        :helpMessage="helpMessage"
        :isLinkMenu="true"
        :isReplaceExplanation="true"
        :isMeetingDate="false"
        @update:editing="onUpdateEditing"
      />
    </div>
  </transition>
</template>

<script>
import MailActionContent from "@/components/organisms/emails/MailActionContent";

export default {
  components: {
    MailActionContent
  },
  props: {
    isOpenEmailMenu: {
      type: Boolean,
      required: true
    },
    bulk: {
      type: Boolean,
      required: true
    },
    chatbots: {
      type: Array,
      required: true
    },
    recordingInterviews: {
      type: Array,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    sendLoadding: {
      type: Boolean,
      required: true
    },
    emailTemplates: {
      type: Array,
      required: true
    },
    sendEmailTemplate: {
      type: Object,
      required: false
    },
    changeEmailTemplate: {
      type: Function,
      required: true
    },
    sendEmailToSeeker: {
      type: Function,
      required: true
    },
    copyLink: {
      type: Function,
      required: true
    },
  },
  methods: {
    tempSaveEmail(bulk){
      if (bulk) {
        localStorage.setItem('sendEmailTemplate'+'[bulk]',JSON.stringify(this.sendEmailTemplate));
      } else {
        localStorage.setItem('sendEmailTemplate'+'['+this.sendEmailTemplate.seeker+']',JSON.stringify(this.sendEmailTemplate));
      }
      alert('一時保存いたしました。')
    },
    helpMessage (msg) {
      this.$buefy.dialog.alert({
        message: msg,
        confirmText: '閉じる'
      })
    },
    onUpdateEditing(isEditing) {
      this.$parent.setEmailEditing && this.$parent.setEmailEditing(isEditing)
    }
  }
}
</script>

<style scoped lang="scss">
.mail-box {
  height: calc(95% - 400px);
  //overflow-y: scroll;
}
.mail-box::-webkit-scrollbar {
  //width:  5px;
  //height: 5px;
  //visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Manage/MailAction.vue